module.exports = __webpack_public_path__ + "img/labor.64b18102.svg";